import React from 'react';

export default function ReportSectionHead({ badge, title, description, actions }) {
  return (
    <header className="hd-reports-section-head mb-4">
      <div className="hd-reports-section-head__main">
        <div className="hd-reports-section-head__text">
          {badge && <span className="hd-page-header__badge">{badge}</span>}
          <h2 className="hd-reports-section-title mb-1">{title}</h2>
          {description && <p className="hd-reports-section-desc mb-0">{description}</p>}
        </div>
        {actions ? <div className="hd-reports-section-head__actions">{actions}</div> : null}
      </div>
    </header>
  );
}
